import React from 'react';
import PublicHero from 'components/Publics/PublicHero';

const ABHero = (props) => {
  const {isLoading, data} = props;
  const {files, accreditation_bodies_name, country_name} = data || {};

  return (
    <PublicHero
      companyType="ab"
      logoFiles={files}
      isLoading={isLoading}
      subtitle={country_name}
      title={accreditation_bodies_name}
    />
  );
};

export default ABHero;
